export default "__VITE_ASSET__YHb9QKek__"